(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Category shortcuts row (mobile): center the active pill and keep the
  // edge fades in sync with the scroll position so hidden pills stay
  // discoverable without a visible scrollbar.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const nav = document.querySelector('.dd-collection-shortcuts');
      if (!nav) return;
      const wrapper = nav.closest('.dd-collection-shortcuts-wrapper');
      const hint = wrapper?.querySelector('.dd-collection-shortcuts__hint');

      const active = nav.querySelector('a[aria-current="page"]');
      if (active && nav.scrollWidth > nav.clientWidth) {
        nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
      }

      const updateFades = () => {
        const overflow = nav.scrollWidth > nav.clientWidth;
        const distanceToEnd = nav.scrollWidth - nav.clientWidth - nav.scrollLeft;
        nav.style.setProperty('--dd-fade-start', overflow && nav.scrollLeft > 8 ? '44px' : '0px');
        nav.style.setProperty('--dd-fade-end', overflow && distanceToEnd > 8 ? '44px' : '0px');
        if (hint) hint.hidden = !overflow || nav.scrollLeft > 8 || distanceToEnd <= 8;
      };
      nav.addEventListener('scroll', updateFades, { passive: true });
      window.addEventListener('resize', updateFades);
      updateFades();
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
